<template>
  <div class="course" :class="cardValid?'has-card':''">
    <div class="banner ban_title">
      <h1>{{ course.title }}</h1>
      <div class="xwz col-lg-12 col-md-12 col-sm-12 text-left">
        <div class="col-lg-6 col-md-6 col-sm-6 text-left">
          <h2>
            专题：{{ (subjectDetail && subjectDetail.venueName) || (course.venueName && course.venueName.name) || '' }}
            <br />
            案例来源：{{ source || (course.lecturer && course.lecturer[0] && course.lecturer[0].company) }}
          </h2>
        </div>
        <!--  col-lg-offset-1 -->
        <div class="col-lg-6 col-md-6 col-sm-6 text-left">
          <h2 class="yy" style="padding-left: 0px">
            会议地点：
            <slot v-if="area_id == 2699">线上</slot>
            <slot v-else-if="area_id == 4488">上海</slot>
            <slot v-else-if="course.venueName && course.venueName.address">{{
              course.venueName.address && course.venueName.address != "未定" ? course.venueName.address : "上海"
            }}</slot>
            <br />
            分享时间：{{ (subjectDetail && subjectDetail.date && global.formatTime(subjectDetail.date, 'Y-M-D')) || (course.venueName && course.venueName.date) }}
          </h2>
        </div>
        <div class="clearfix"></div>
      </div>
    </div>
    <div class="pc_content course_detail">
      <div class="con">
        <slot v-if="course.lecturer && course.lecturer[0]">
          <slot v-for="(item, index) in course.lecturer">
            <div class="lecturer" :key="'course_lecturer_' + index">
              <div class="le">
                <div class="tupian_con">
                  <router-link :to="formatHref('/teacher', {tid: item.id})">
                    <div class="tupian img-circle row">
                      <div class="img_per">
                        <img :src="global.getSrc(item.thumbs)" class="img-circle" width="600px" height="600px" />
                      </div>
                    </div>
                  </router-link>
                </div>
              </div>
              <div class="ri">
                <div class="row">
                  <h3>{{ item.name }}</h3>
                  <h3 v-if="course.companythumbs && course.companythumbs != '0'">&nbsp;|</h3>
                  <img :src="course.companythumbs" height="34" v-if="course.companythumbs && course.companythumbs != '0'" />
                </div>
                <div class="row">
                  <h5>{{ item.company }} {{ item.position }}</h5>
                </div>
                <div class="row">
                  <p v-html="item.desc || ''"></p>
                </div>
              </div>
            </div>
            <div class="clearfix" :key="'course_lecturer_cl_' + index"></div>
          </slot>
        </slot>
        <div class="course_info">
          <div class="menu" v-if="showPPT==='menu'">
            <button type="button" :class="menuSelected===0?'selected':''" @click="selectMenu(0)">
              <i></i>查看详情<i></i>
            </button>
            <button type="button" :class="menuSelected===1?'selected':''" @click="selectMenu(1)">
              <i></i>查看PPT<i></i>
            </button>
          </div>
          <slot v-if="!showPPT || showPPT==='ppt' || (showPPT==='menu' && menuSelected==0)">
            <div class="course_summary row">
              <div class="le">
                <img src="../assets/img/before_train/train_dagang.png" />
              </div>
              <div class="ri">
                <!-- <h3>课程概要</h3> -->
                <h3>分享概要</h3>
                <p v-html="courseDesc"></p>
              </div>
            </div>
            <div class="course_summary row" :style="($route.query&&$route.query.dif)?'padding-bottom:40px;':''">
              <div class="le">
                <img src="../assets/img/before_train/train_shouyi.png" />
              </div>
              <div class="ri">
                <h3>听众收益</h3>
                <p v-html="course.profit"></p>
              </div>
            </div>
          </slot>
          <div class="course_summary row" v-if="!($route.query&&$route.query.dif) && (showPPT==='ppt' || (showPPT==='menu' && menuSelected==1))">
            <div class="le">
              <img src="../assets/img/before_train/train_summary.png" />
            </div>
            <div class="ri">
              <h3>PPT</h3>
              <PPT
                :limit="{time:timeLimit,ticket:ticketLimit,token}"
                :list="coursePPT"
                :page="page"
                @topreview="toPreview"
              ></PPT>
            </div>
          </div>
        </div>
        <div class="clearfix"></div>
      </div>
    </div>
    <div class="pc_content course_cases" v-if="!($route.query&&$route.query.dif)">
      <div class="con">
        <h1 class="h1">相关案例</h1>
        <Cases :datalist="course.related"></Cases>
      </div>
    </div>
    <!-- card -->
    <!-- <Card v-if="showCard" :detail="course" :type="'course'" data-desc="已停用,改为下述Poster组件"></Card> -->
    <!-- <Poster v-if="showCard" :_sid="area_id" :_dataselected="course" :_kind="'course'" :key="'menu'+course_id" @setvalid="getValid"></Poster> -->
    <!-- ppt预览 -->
    <!-- <div class="pre-url" v-if="preUrl && preUrl.length > 0" @click="preUrl = ''">
      <img :src="preUrl" alt="" @click.stop>
    </div> -->
    <div class="ppt_preview" v-if="preUrl && preUrl.length > 0" @click="closePreview">
      <div class="arrow-left" :class="preUrlIndex==0?'is-disable':''" @click.prevent="reducePreview">
        <i class="el-icon-d-arrow-left"></i>
      </div>
      <div class="ppt_list" :style="`--active-index:${preUrlIndex};`" ref="pptPreview1">
        <div class="ppt_content" v-for="(item, index) in coursePPT" :key="'list'+index" ref="pptPreview2">
          <img :src="item.url" alt="" @click="stopClick">
        </div>
      </div>
      <div class="arrow-right" :class="preUrlIndex==(coursePPT.length-1)?'is-disable':''" @click.prevent="addPreview">
        <i class="el-icon-d-arrow-right"></i>
      </div>
    </div>
    <!-- 按钮组 -->
    <div class="btn-group">
      <!-- 收藏/取消收藏 -->
      <div class="b-collect wrap-flex">
        <el-tooltip class="item" effect="dark" content="请先登录" placement="left" v-if="collectStatus===null">
          <el-button icon="el-icon-star-off" disabled>收藏案例</el-button>
        </el-tooltip>
        <el-button icon="el-icon-star-off" v-else-if="collectStatus" @click="cancelCollect" type="primary">取消收藏</el-button>
        <el-button icon="el-icon-star-off" v-else @click="toCollect" type="primary" plain>收藏案例</el-button>
      </div>
      <!-- 海报 -->
      <Poster :link="poster" keyword="案例"></Poster>
      <!-- 查看ppt -->
      <div class="b-ppt wrap-flex">
        <el-button icon="el-icon-picture-outline" @click="fixPPT()" type="primary" plain>查看PPT</el-button>
      </div>
      <!-- 购买/下载ppt -->
      <div class="b-ppt wrap-flex" v-if="pptMLimit">
        <ppt-manage @manage="getPPTManage" @checkbuy="checkBuy" :pptlink="pptLink" :coursetitle="course.title"></ppt-manage>
      </div>
    </div>
  </div>
</template>

<script>
import { mixinSession } from '../mixin'

export default {
  name: 'Course',
  mixins: [mixinSession],
  components: {
    // Card: ()=>import('../components/Card.vue'),
    Cases: () => import('../componentsNew/Cases.vue'),
    // Poster: () => import('../components/poster/Menus.vue'),
    Poster: () => import('../componentsNew/Poster.vue'),
    PPT: () => import('../componentsNew/CoursePPT'),
    pptManage: () => import('../componentsNew/CoursePPTTicket.vue')
  },
  props: [ 'cid', 'param' ],
  data () {
    return {
      area_id: '',
      course_id: '',
      course: {},
      coursePPT: [],
      pptLink: '',
      menuSelected: 0,
      page: 0,
      token: '',
      timeLimit: false,
      ticketLimit: false, // 是否有票
      subjectDetail: {},
      source: '',
      preUrl: '',
      preUrlIndex: 0,
      metaInfo: {
        seoTitle: '',
        seoKeyword: '',
        seoDescription: ''
      },
      // poster
      poster: '',
      showCard: false,
      cardValid: false,
      // collect
      collectStatus: null,
      // ppt
      showPPT: false, // 暂未使用
      pptGoodsId: '', // ppt商品id
      pptBuy: false, // 是否购买ppt或门票
      lastDay: 0, // 最后一天时间 时间戳
      theTime: new Date().getTime()
    }
  },
  computed: {
    pptMLimit () { // 是否启用ppt按钮
      // return true
      return Boolean(this.pptLink && (this.theTime >= (this.lastDay + 2 * this.global.timestamp))) // 会后2天后启用
      // return Boolean(this.coursePPT && (this.coursePPT.length > 0) && (this.theTime >= (this.lastDay + 3 * this.global.timestamp))) // 会后3天后启用
      // return this.$route.query && this.$route.query.ppt
    },
    courseDesc () {
      // return (this.course && this.course.desc) || ''
      return ((this.course && this.course.desc) || '').replace(/题纲/g, '提纲')
    }
  },
  metaInfo () {
    const { metaInfo, course, subjectDetail } = this
    // course.title + ' - MPD ' + this.global.config[this.area_id].title || ''
    const seoTitle = metaInfo.seoTitle || `课程详情${course.title ? ' - ' + course.title : ''}`
    const seoKeyword = metaInfo.seoKeyword || (subjectDetail && subjectDetail.venueName) || (course.venueName && course.venueName.name) || ''
    const seoDescription = metaInfo.seoDescription || (course.desc || '').slice(0, 150) || ''
    return {
      title: seoTitle,
      meta: [
        { name: 'keywords', content: seoKeyword },
        { name: 'description', content: seoDescription }
      ]
    }
  },
  watch: {
    param: {
      handler (param, oldParam) {
        if (param && typeof param === 'object' && !this.global.compareObject(param, oldParam)) {
          this.token = localStorage.getItem('token') || ''
          this.timeLimit = false
          this.ticketLimit = false
          this.area_id = param.sid || this.global.area_id || ''
          this.course_id = param.cid
          this.subject_id = param.vid || ''
          this.source = decodeURIComponent(param.source || '')
          // this.showPPT = param.more || false // ppt测试参数
          this.showPPT = 'ppt' // 'menu'
          // this.showCard = false // 海报测试参数
          this.showCard = true
          this.course = {}
          this.getCourse()
          this.checkLimit()
          // this.checkOrder()
          // this.getPPT()
          this.getCard()
        }
      },
      immediate: true,
      deep: true
    },
    course: {
      handler (_new, _old) {
        if (_new && this.global.isObjectKeys(_new) && (!_old || !this.global.compareObject(_new, _old))) {
          let time = new Date()
          let year = time.getFullYear()
          let month = time.getMonth() + 1
          let day = time.getDate()
          let hour = time.getHours()
          let date = _new.venueName && _new.venueName.date
          let startYear = year
          let startMonth = month
          let startDay = day
          let startHour = hour
          if (date && date.length > 0) {
            if (date.split('-')[0]) {
              startYear = date.split('-')[0]
            }
            if (date.split('-')[1]) {
              startMonth = date.split('-')[1]
            }
            if (date.split('-')[2]) {
              startDay = date.split('-')[2].split(' ')[0]
              if (date.split('-')[2].split(' ')[1]) {
                startHour = date.split('-')[2].split(' ')[1].split(':')[0]
              }
            }
          }
          startYear = parseInt(startYear)
          startMonth = parseInt(startMonth)
          startDay = parseInt(startDay)
          startHour = parseInt(startHour)
          if (
            (year > startYear) ||
            (year === startYear && month > startMonth) ||
            (year === startYear && month === startMonth && day > startDay) ||
            (year === startYear && month === startMonth && day === startDay && (hour >= startHour))
          ) {
            this.timeLimit = true
          }
        }
      },
      immediate: true,
      deep: true
    }
  },
  created () {
    this.getSimInfo()
  },
  methods: {
    getSimInfo () {
      let purl = this.global.urlNew.place + this.global.area_id
      this.$http
        .jsonp(purl)
        .then((res) => {
          return res.json()
        })
        .then((res) => {
          // console.log(res)
          if ((res.status === 200 || res.status === '200') && res.data && res.data.endTime) {
            let y = new Date(res.data.endTime * 1000).getFullYear()
            let m = new Date(res.data.endTime * 1000).getMonth()
            let d = new Date(res.data.endTime * 1000).getDate() + 1
            this.lastDay = new Date(y, m, d, 0, 0, 0).getTime()
          }
        })
    },
    checkLimit () {
      if (this.token) {
        // let url = `${this.global.urlNew['getMyTicket']}?token=${this.token}&type='mpd'&sid=${this.area_id}&relation=true`
        let url = `${this.global.urlNew['getMyActiveTicket']}?token=${this.token}&type='mpd'&sid=${this.area_id}&relation=true`
        this.$http
          .jsonp(url)
          .then((data) => {
            return data.json()
          })
          .then((res) => {
            // console.log('ticket ', res)
            this.ticketLimit = res.status === '200' && res.data && res.data[0]
            console.log('ticket ', res, this.ticketLimit)
            if (this.ticketLimit) {
              this.getPPT()
            }
          })
      }
    },
    getSubject (vid) {
      // console.log('get_Subject ', vid)
      let surl = this.global.urlNew.subject_detail + (vid || this.subject_id)
      this.$http.jsonp(surl)
        .then((data) => {
          return data.json()
        })
        .then((data) => {
          if ([0, '0'].includes(data.errno)) {
            console.log('SubjectDetail ', vid, data.data)
            this.subjectDetail = data.data || {}
          }
        })
    },
    getCourse () {
      let curl = `${this.global.urlNew.course['course']}${this.area_id}/${this.course_id}`
      this.$http
        .jsonp(curl)
        .then((data) => {
          return data.json()
        })
        .then((data) => {
          if (data.errno === '0') {
            console.log("course ", data.data, data.data.venueName);
            this.course = data.data
            if (this.course.venueName) {
              // 特殊时间处理
              this.course.venueName.date = (this.course.venueName.date || '')
                .replace('2026-05-30 15:50-16:50', '2026-05-30 15:30-16:30')
            }
            if (data.data.seo !== null && !Array.isArray(data.data.seo)) {
              this.metaInfo = data.data.seo
            }
            // if (this.metaInfo.seoTitle === '') {
            //   this.metaInfo.seoTitle = data.data.title + ' - MPD ' + this.global.config[this.area_id].title || ''
            // }
            // this.subject_id = (data.data.venueName && data.data.venueName.id) || this.subject_id || ''
            this.getSubject()
            this.checkCollect()
            this.$forceUpdate()
          }
        })
    },
    checkOrder () {
      const url = `${this.global.urlNew['getMyActiveTicket']}?token=${this.token}&type='mpd'&sid=${this.area_id}&relation=true`
      // getTicketActive(aid, this.token)
      this.$http.jsonp(url)
        .then((data) => {
          return data.json()
        })
        .then(res => {
          console.log('get_Activation_Ticket__ ', res)
          let status = res.status && res.status.toString() && res.status.toString().trim()
          if (status === '200' && res.data) {
            this.orderLimit = Boolean(res.data.length > 0)
            if (this.orderLimit) {
              this.getPPT()
            }
          }
        })
    },
    getPPT () {
      // let curl = `${this.global.urlNew.course['ppt']}?sid=${2898}&cid=${15807}&token=${this.token}&choose=1` // 测试ppt
      let curl = `${this.global.urlNew.course['ppt']}?sid=${this.area_id}&cid=${this.course_id}&token=${this.token}&choose=1`
      this.$http
        .jsonp(curl)
        .then((data) => {
          return data.json()
        })
        .then((data) => {
          console.log('course-ppt ', curl, data)
          if (data.errno === 0 || data.errno === '0') {
            this.coursePPT = (data.data && data.data.attachment && data.data.attachment.imgs) || []
            this.pptLink = (data.data.attachment && data.data.attachment.pdf) || ''
          }
        })
    },
    selectMenu (num) {
      this.menuSelected = num
    },
    getValid (res) {
      // console.log('res ', res)
      this.cardValid = false
      if (res) {
        this.cardValid = true
      }
    },
    //
    stopClick (e) {
      e.stopPropagation()
    },
    toPreview (res) {
      console.log('toPreview ', res)
      const {url, index} = res || {}
      this.preUrl = url || ''
      this.preUrlIndex = index || 0
    },
    closePreview () {
      this.preUrl = ''
      this.preUrlIndex = 0
    },
    reducePreview (e) {
      this.stopClick(e)
      if (this.preUrlIndex > 0) {
        this.preUrlIndex--
      }
    },
    addPreview (e) {
      this.stopClick(e)
      if (this.preUrlIndex < (this.coursePPT.length - 1)) {
        this.preUrlIndex++
      }
    },

    getPPTManage (goodsId) {
      // console.log('get_PPT_Manage__', goodsId)
      this.pptGoodsId = goodsId || ''
    },
    checkBuy (res) {
      this.pptBuy = res || false
    },
    fixPPT () {
      // eslint-disable-next-line no-undef
      console.log('ppt ', $('.course-ppt'))
      // eslint-disable-next-line no-undef
      if ($('.course-ppt')) {
        // eslint-disable-next-line no-undef
        let offset = $('.course-ppt').offset().top - 300
        // eslint-disable-next-line no-undef
        $(window).scrollTop(offset)
      }
    },
    // 收藏
    checkCollect () {
      this.collectStatus = null
      if (this.token) {
        const url = `${this.global.urlNew['collect']['check']}&sid=${this.area_id}&courseId=${this.course_id}&token=${this.token}`
        this.$http.jsonp(url)
          .then(data => {
            return data.json()
          })
          .then(res => {
            // console.log(res)
            if (res.status) {
              if ([200, '200'].includes(res.status)) {
                this.collectStatus = true
              } else {
                this.collectStatus = false
              }
            }
          })
      }
    },
    toCollect () {
      if (this.token) {
        const url = `${this.global.urlNew['collect']['change']}&sid=${this.area_id}&courseId=${this.course_id}&token=${this.token}`
        this.$http.jsonp(url)
          .then(data => {
            return data.json()
          })
          .then(res => {
            // console.log('a', res)
            if (res.status && [200, '200'].includes(res.status)) {
              this.collectStatus = true
            }
          })
      }
    },
    cancelCollect () {
      if (this.token) {
        const url = `${this.global.urlNew['collect']['change']}&sid=${this.area_id}&courseId=${this.course_id}&token=${this.token}`
        this.$http.jsonp(url)
          .then(data => {
            return data.json()
          })
          .then(res => {
            // console.log('r', res)
            if (res.status && [200, '200'].includes(res.status)) {
              this.collectStatus = false
            }
          })
      }
    },
    // 海报
    getCard () {
      this.$http.jsonp(this.global.urlNew.poster.info + this.global.area_id)
        .then(data => {
          return data.json()
        })
        .then(res => {
          if ([200, '200'].includes(res.status) && res.data) {
            const cards = res.data || {}
            let cardId = ''
            for (let item of Object.values(cards)) {
              if (item.type === 2) {
                if (!cardId || cardId < item.id) {
                  cardId = item.id
                }
              }
            }
            if (cardId) {
              const url = `${this.global.urlNew.poster.active}?sid=${this.global.area_id}&cardId=${cardId}&courseId=${this.course_id}`
              this.$http.jsonp(url)
                .then(data => {
                  return data.json()
                })
                .then(res => {
                  console.log('poster ', res)
                  this.poster = (res.data && res.data.finishedImg) || ''
                  // this.poster = (res.data && res.data.bottomBackground) || ''
                  this.cardValid = Boolean(this.poster)
                })
            }
          }
        })
    }
  }
}
</script>

<style lang="scss">
#app .course {
  &.has-card {
    @media (max-width: 1124px) {
      .banner {
        height: 340px;
      }
      .banner.ban_title {
        h1 {
          padding-top: 110px;
        }
      }
    }
    @media (max-width: 767px) {
      .banner {
        height: fit-content;
      }
      .banner.ban_title {
        h1 {
          padding-top: 35px;
          padding-left: 20px;
          padding-right: 125px;
        }
      }
    }
    @media (max-width: 540px) {
      .banner.ban_title {
        h1 {
          text-align: left;
        }
      }
    }
  }
  .banner.ban_title {
    display: grid !important;
    align-content: flex-start !important;
    align-items: flex-start !important;
    h1 {
      width: 100%;
      max-width: 1000px;
      font-size: 36px;
      line-height: 40px;
      padding-top: 90px;
      letter-spacing: 1px;
    }
    .xwz {
      // max-width: 750px;
      // height: 150px;
      width: 100%;
      min-width: 540px;
      max-width: 750px;
      margin: 0 auto;
      padding: 0;
      >div {
        // width: 50%;
        padding: 0;
      }
      h2 {
        font-size: 15px;
        color: #ffffff;
        line-height: 22px;
        padding-top: 24px;
      }
    }
  }
  .pc_content.course_detail {
    .con {
      max-width: 1020px;
      margin-top: 90px;
      border-bottom: 1px solid #cccccc;
      .lecturer {
        width: 100%;
        display: flex;
        flex-wrap: nowrap;
        &:not(:nth-of-type(1)) {
          margin-top: 80px;
        }
        .le {
          width: 25%;
          padding: 0;
          .tupian_con {
            width: 80%;
            margin: 0 auto;
            .tupian {
              border: 7px solid var(--main-bgcolor);
              // border-radius: 50%;
              margin-left: 0;
              margin-right: 0;
              .img_per {
                width: 100%;
                margin: 0 auto;
                background-size: 100%;
                img {
                  width: 100%;
                  height: 100%;
                  object-fit: cover;
                  object-position: top;
                  border: 5px solid #ffffff;
                }
              }
            }
          }
        }
        .ri {
          width: 75%;
          .row {
            margin-left: 0;
            margin-right: 0;
            display: flex;
            flex-wrap: nowrap;
            justify-content: flex-start;
            align-items: center;
            h3 {
              height: 40px;
              float: left;
              font-size: 30px;
              line-height: 40px;
              margin-top: 0;
              margin-bottom: 0;
              &:nth-of-type(2) {
                line-height: 36px;
              }
            }
            img {
              height: 34px;
              float: left;
              margin-left: 18px;
            }
            h5 {
              font-size: 16px;
              margin-top: 15px;
              margin-bottom: 17px;
            }
            p {
              font-size: 16px;
              color: #666666;
              line-height: 30px;
            }
          }
        }
      }
      .course_info {
        margin-top: 160px;
        margin-bottom: 20px;
        width: 100%;
        .menu {
          // margin-top: -70px;
          margin-top: -60px;
          margin-bottom: 60px;
          padding-left: 25px;
          padding-right: 25px;
          // padding-bottom: 30px;
          // border-bottom: 1px solid #cccccc;
          padding-top: 30px;
          border-top: 1px solid #cccccc;
          text-align: center;
          button {
            width: 120px;
            height: 40px;
            font-size: 18px;
            font-weight: 500;
            color: #333;
            background-color: transparent;
            outline: none;
            border: none;
            border-radius: 6px;
            // border-top-right-radius: 8px;
            // border-bottom-left-radius: 8px;
            position: relative;
            z-index: 2;
            &:not(:nth-last-of-type(1)) {
              margin-right: 25px;
            }
            i {
              display: inline-block;
              width: 8px;
              height: 8px;
              background-color: #ffffff;
              border: 2px solid var(--main-bgcolor);
              border-radius: 8px;
              position: absolute;
              z-index: 2;
              &:nth-of-type(1) {
                top: -1px;
                left: -1px;
              }
              &:nth-last-of-type(1) {
                bottom: -1px;
                right: -1px;
              }
            }
            &.selected {
              // border: 3px solid var(--deep-color);
              // background-color: rgba(0,12,136,0.9);
              background-color: rgba(1,75,214,1);
              color: #ffffff;
            }
            &::before, &::after {
              content: '';
              display: inline-block;
              width: 85%;
              height: 80%;
              position: absolute;
              z-index: 1;
              background-color: rgba(1,75,214,0.1);
            }
            &::before {
              top: 0;
              left: 0;
              border-left: 2px solid var(--main-bgcolor);
              border-top: 2px solid var(--main-bgcolor);
              border-top-left-radius: 8px;
            }
            &::after {
              bottom: 0;
              right: 0;
              border-right: 2px solid var(--main-bgcolor);
              border-bottom: 2px solid var(--main-bgcolor);
              border-bottom-right-radius: 8px;
            }
          }
        }
        .course_summary {
          &:not(:nth-last-of-type(1)) {
            margin-bottom: 100px;
          }
          .le {
            width: 10%;
            float: left;
            padding-left: 15px;
            img {
              max-width: 100%;
              background-color: var(--main-bgcolor);
            }
          }
          .ri {
            width: 89%;
            float: left;
            padding-left: 1%;
            padding-right: 1%;
            h3 {
              padding-top: 10px;
              padding-bottom: 10px;
              font-size: 30px;
            }
            p {
              color: #666666;
              font-size: 16px;
              line-height: 30px;
              margin-bottom: 0;
            }
          }
          .course-ppt {
            margin-top: 20px;
            margin-bottom: 30px;
          }
        }
      }
    }
  }
  .pc_content.course_cases {
    .con {
      margin-bottom: 60px;
      h1 {
        padding-top: 50px;
        padding-bottom: 40px;
      }
    }
  }
  .pre-url {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 999;
    background-color: rgba(0, 0, 0, 0.5);
    img {
      width: auto;
      height: auto;
      max-width: 80vw;
      max-height: 80vh;
      // position: absolute;
      // top: 50%;
      // left: 50%;
      // transform: translate(-50%, -50%);
    }
  }
  .ppt_preview {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 200;
    background-color: rgba(0, 0, 0, 0.5);
    display: grid;
    // justify-content: center;
    justify-content: flex-start;
    align-items: center;
    // overflow: auto;
    overflow: hidden;
    // pointer-events: all;
    --active-index: 0;
    .arrow-left, .arrow-right {
      position: fixed;
      color: #ffffff;
      top: 50vh;
      z-index: 999;
      transform-origin: center center;
      font-size: 36px;
      cursor: pointer;
      user-select: none;
      text-shadow: #999999 1px 0 10px;
      transform: translateY(-50%);
      &.is-disable {
        opacity: .4;
      }
    }
    .arrow-left {
      left: 0;
      right: auto;
      padding-right: 15px;
    }
    .arrow-right {
      left: auto;
      right: 0;
      padding-left: 15px;
    }
    .ppt_list {
      width: fit-content;
      height: 100vh;
      margin-left: calc(100vw * var(--active-index) * -1);
      display: flex;
      flex-wrap: nowrap;
      justify-content: flex-start;
      align-items: center;
      background: transparent;
      transition: margin 0.3s linear;
    }
    .ppt_content {
      width: 100vw;
      height: 100vh;
      padding: 15px;
      display: grid;
      justify-content: center;
      align-items: center;
      background: transparent;
      overflow: auto;
    }
    img {
      width: 60vw;
      min-width: 700px;
      max-width: 1200px;
      height: auto;
      max-height: 100vh;
      margin-top: 0;
      margin-bottom: 0;
    }
  }
  .clearfix {
    z-index: 0 !important;
  }
  @media (max-width: 767px) {
    .banner.ban_title {
      height: fit-content;
      h1 {
        font-size: 22px;
        line-height: 25px;
        padding-top: 35px;
        padding-bottom: 25px;
        // padding-top: 30px;
        // padding-bottom: 20px;
      }
      .xwz {
        min-width: 0;
        height: fit-content;
        padding-bottom: 25px;
        div {
          h2 {
            font-weight: 400;
            text-align: center;
            padding-top: 0;
          }
        }
      }
    }
    .pc_content.course_detail {
      .con {
        // margin-top: 15px;
        margin-top: 30px;
        .lecturer {
          width: 100%;
          padding: 0 4%;
          &:not(:nth-of-type(1)) {
            margin-top: 15px;
          }
          .le {
            width: 34%;
            padding-right: 4%;
            .tupian_con {
              width: 100%;
              .tupian {
                border-width: 4px;
                margin-left: 0;
                margin-right: 0;
                .img_per {
                  img {
                    border-width: 3px;
                  }
                }
              }
            }
          }
          .ri {
            width: 100%;
            // padding-top: 20px;
            padding-top: 5px;
            padding-right: 0;
            .row {
              h3 {
                font-size: 18px;
                height: 20px;
                line-height: 20px;
                &:nth-of-type(2) {
                  line-height: 18px;
                }
              }
              img {
                height: 20px;
                margin-left: 12px;
              }
              h5 {
                font-size: 13px;
              }
              p {
                display: none;
              }
            }
          }
        }
        .course_info {
          margin-top: 40px;
          .menu {
            margin-top: 0;
            margin-bottom: 50px;
            padding-left: 15px;
            padding-right: 15px;
            padding-top: 15px;
            // padding-bottom: 15px;
            button {
              width: 85px;
              height: 30px;
              font-size: 14px;
              &:not(:nth-last-of-type(1)) {
                margin-right: 20px;
              }
            }
          }
          .course_summary {
            // &:nth-of-type(2) {
            //   margin-top: 40px;
            // }
            &:not(:nth-last-of-type(1)) {
              margin-bottom: 60px;
            }
            .le {
              width: 0;
              img {
                width: auto;
                max-width: fit-content;
                height: 26px;
              }
            }
            .ri {
              h3 {
                line-height: 26px;
                font-size: 20px;
                padding-top: 0;
                padding-bottom: 0;
                padding-left: 32px;
              }
              p {
                font-size: 13px;
                line-height: 24px;
                padding-top: 10px;
              }
            }
            .course-ppt {
              margin-bottom: 15px;
            }
          }
        }
      }
    }
    .pc_content.course_cases {
      .con {
        h1 {
          padding-top: 35px;
          padding-bottom: 25px;
        }
      }
    }
    .ppt_preview {
      .arrow-left, .arrow-right {
        font-size: 28px;
      }
      img {
        width: 90vw;
        min-width: 0;
      }
    }
  }
  [class*='el-col-'] {
    float: none;
  }
  .btn-group {
    text-align: right;
    position: fixed;
    right: 1px;
    bottom: 80px;
    z-index: 1000;
    text-align: right;
    div[class*='b-'] {
      text-align: right;
      justify-content: flex-end;
      align-items: center;
    }
    .el-button {
      width: fit-content;
      min-width: 115px;
      line-height: 1;
      margin-top: 10px;
      padding: 8px 12px;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      i {
        font-size: 20px;
      }
      span {
        font-size: 16px;
      }
    }
  }
  @media (max-width: 750px) {
    .btn-group {
      bottom: 60px;
      .el-button {
        padding: 6px 9px;
        i {
          font-size: 17px;
        }
        span {
          font-size: 14px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/viewsNew/Course.vue